<template>
  <div style="display: contents">
    <tr>
      <td colspan="3"></td>
      <td class="bg-primary">
        <b-icon :icon="collapsed ? 'dash-square' : 'plus-square'" @click="collapsed = !collapsed" variant="light"/>
        <!-- <b-btn variant="outline-secondary btn-xs" @click="collapsed = !collapsed">
          <b-icon :icon="collapsed ? 'dash' : 'plus'" scale="1.3"/>
        </b-btn> -->
      </td>
      <td colspan="7" class="bg-primary">
        <span class="font-weight-bold text-white">{{ item.description }}</span>
      </td>
    </tr>
    <template v-if="collapsed">
      <BookingItemResult
        v-for="(item, itemIndex) in item.items"
        :item="item"
        :booking="booking"
        :key="'pitem' + itemIndex" />
    </template>
  </div>
</template>

<script>
import BookingItemResult from './booking_item_result'

export default {
  name: 'PackageItemResult',
  props: ['item', 'booking'],
  components: { BookingItemResult },
  data () { return { collapsed: false } }
}
</script>
